import  { useEffect, useState } from 'react';
import styled from 'styled-components';
import SelectWheel from '../../atoms/SelectWheel';
import MainButton from '../../atoms/MainButton';

const Container = styled.div`
  width: 100%;
  height: 180px;
  display: flex;
  justify-content: center;
  font-size: 1.5rem;
  color: ${(props) => props.theme.colors.primary};
  position: relative;
`
const WheelWrapper = styled.div`
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`
const SelectedBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  text-align: center;
  line-height: 40px;
  top: 50%;
  left: 0;
  right: 0;
  width: 100%;
  height: 40px;
  background-color: ${(props) => props.theme.colors.neutral[300]};
  transform: translateY(-50%);
  pointer-events: none;
  border-radius: 10px;
`
const ButtonWrapper = styled.div`
  margin-top: 40px;
`

const DatePicker = ({ initialDate, onDateSelect }) => {

  const initialYear = initialDate.getFullYear();
  const initialMonth = initialDate.getMonth() + 1;
  const initialDay = initialDate.getDate();

  const startYear = 1910;
  const years = Array.from({ length: 2050 - startYear + 1 }, (v, i) => startYear + i);
  const months = Array.from({ length: 12 }, (v, i) => i + 1);

  const [selectedYear, setSelectedYear] = useState(initialYear);
  const [selectedMonth, setSelectedMonth] = useState(initialMonth);
  const [selectedDay, setSelectedDay] = useState(initialDay);

  const getLastDayOfMonth = (year, month) => {
    return new Date(year, month, 0).getDate();
  };

  useEffect(() => {
    const lastDay = getLastDayOfMonth(selectedYear, selectedMonth);
    
    // selectedDay가 lastDay보다 크다면 lastDay로 조정, 그렇지 않으면 유지
    setSelectedDay((prevDay) => Math.min(prevDay, lastDay));
  }, [selectedYear, selectedMonth]);
  
  
  const handleYearChange = (year) => {
    setSelectedYear(year);
  };

  const handleMonthChange = (month) => {
    setSelectedMonth(month);
  };

  const handleDayChange = (day) => {
    setSelectedDay(day);
  };
  
  const handleDatePick = () => {
    const selectedDate = `${selectedYear}-${String(selectedMonth).padStart(2, '0')}-${String(selectedDay).padStart(2, '0')}`;
    onDateSelect(selectedDate);
  }

  return (
    <>
      <Container>
        <SelectedBox/>
        <WheelWrapper>
          <SelectWheel list={years} onChange={handleYearChange} selected={selectedYear} borderStyle="left" isLoop={true}/>
        </WheelWrapper>
        <WheelWrapper>
          <SelectWheel list={months} onChange={handleMonthChange} selected={selectedMonth} borderStyle="middle" isLoop={true}/>
        </WheelWrapper>
        <WheelWrapper>
          <SelectWheel
            list={Array.from({ length: getLastDayOfMonth(selectedYear, selectedMonth) }, (v, i) => i + 1)}
            onChange={handleDayChange}
            selected={selectedDay}
            borderStyle="right"
            isLoop={true}
          />
        </WheelWrapper>
      </Container>
      <ButtonWrapper>
        <MainButton
          $variant="primary" 
          title="선택"
          onClick={handleDatePick}/>
      </ButtonWrapper>
    </>
    
  );
};

export default DatePicker;